import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AnalyticsEvent, AnalyticsService, RunMethodType } from '@mode/shared/util-segment';

@Component({
  selector: 'mode-promo-popover',
  templateUrl: './promo-popover.component.html',
  styleUrls: ['./promo-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromoPopoverComponent {
  @Input() trialLink = 'https://mode.com/compare-plans/';
  @Input() isTrialExpired = false;
  @Input() userEmail = '';
  @Input() userDisplayName = '';

  public readonly startTrialElementId = '2';
  public benefits: ReadonlyArray<string> = [
    "Run anyone's reports, anytime",
    'Schedule automatic runs',
    'Collaboratively edit reports',
  ];

  constructor(private analyticsService: AnalyticsService) {}

  // send 'UI Clicked' event to segment
  trackClick(location: string, action: string): void {
    this.analyticsService.run(RunMethodType.Track, AnalyticsEvent.Name.UiClicked, {
      location: location,
      action: action,
      email: this.userEmail,
    });
  }
}
